<template>
  <div>
    <form
        id="PayForm"
        target="PayForm"
        :action="payRequestUrl"
        method="POST">
      <input type="hidden" name="hpNo" v-model="this.orderPhoneNumber">
      <input type="hidden" name="cartKey" v-model="this.payInfo.cart_key">
      <input type="hidden" name="corpCode" v-model="this.payInfo.corp_code">
      <input type="hidden" name="upjangCode" v-model="this.payInfo.upjang_code">
      <input type="hidden" name="parcelAddr" v-model="this.payInfo.parcel_addr">
      <input type="hidden" name="parcelAddrDetail" v-model="this.payInfo.parcel_addr_detail">
      <input type="hidden" name="parcelOrderName" v-model="this.payInfo.parcel_order_name">
      <input type="hidden" name="parcelPostNo" v-model="this.payInfo.parcel_post_no">
      <input type="hidden" name="parcelReceiptHpNo" v-model="this.payInfo.parcel_receipt_hp_no">
      <input type="hidden" name="parcelReceiptName" v-model="this.payInfo.parcel_receipt_name">
      <input type="hidden" name="parcelRecmName" v-model="this.payInfo.parcel_recm_name">
      <input type="hidden" name="rcvMsg" v-model="this.payInfo.rcv_msg">
      <input type="hidden" name="requestMsg" v-model="this.payInfo.request_msg">
      <input type="hidden" name="selectCalc" v-model="this.payInfo.select_calc">
      <input type="hidden" name="selectRcv" v-model="this.payInfo.select_rcv">
      <input type="hidden" name="selectRcvOutlet" v-model="this.payInfo.select_rcv_outlet">
      <input type="hidden" name="sendOutDate" v-model="this.payInfo.send_out_date">
      <input type="hidden" name="tableNo" v-model="this.payInfo.table_no">
      <input type="hidden" name="dcInfo" v-model="this.payInfo.dc_info">
      <input type="hidden" name="paymentCardSetting" v-model="this.payInfo.payment_card_setting">
      <input type="hidden" name="sp_return_url" v-model="this.payResponseUrl">
      <input type="hidden" name="sp_auth_url" v-model="this.orderResponseUrl">
    </form>

    <div style="position:static; z-index:0; height: 50px; border: none;">
      <div class="text-center pt-12">
        카드 결제중입니다.<br>
        잠시만 기다려주세요.
      </div>
    </div>
    <iframe
        name="PayForm"
        style="z-index:10; position:absolute; width: 100vw; height: 85vh; top: 104px; border: none;"></iframe>
  </div>
</template>

<script>
import authStore from "@/store/auth";
import payStore from "@/store/pay";
import cartStore from "@/store/cart";

export default {
  name: "PaymentRequest",
  data() {
    return {
      orderPhoneNumber: '',
      orderResponseUrl: process.env.VUE_APP_SERVER_URL + "/easypay/order_res",
      payRequestUrl: process.env.VUE_APP_SERVER_URL + "/easypay/req",
      payResponseUrl: process.env.VUE_APP_SERVER_URL + "/easypay/easypay_order_res_submit",
      isAuth: false,
      payInfo: {},
      dataReceived: false,
    }
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    if (authStore.state.authInfo.token !== null) {
      this.orderPhoneNumber = authStore.state.authInfo.phoneNumber
    }


    this.payInfo = payStore.state.payInfo
    console.log('this.payInfo', this.payInfo)
    console.log('payStore.state.payInfo', payStore.state.payInfo)

  },
  mounted() {
    document.querySelector('#PayForm').submit()

    window.addEventListener('message', (e) => {
      // 전달 된 데이터
      console.log(e.data.functionName);

      // 부모창의 함수 실행
      if (e.data.functionName === 'paymentResult') {
        console.log("vue get result");
        console.log(e.data.resultData);
        this.paymentResult(e.data.resultData);
      }
    });
  },
  methods: {
    sendForm() {
      document.querySelector('#PayForm').submit()
    },
    paymentResult(resultData) {
      if(!this.dataReceived) {
        this.dataReceived = true;
      } else {
        return
      }

      if(resultData.resultCode === '0000') {
        cartStore.dispatch('removeCartInfo')
        payStore.dispatch('removePayInfo')
        //  영업일자, 영수증번호, 영업장코드
        this.$router.push('/order/'+resultData.saleDate +'/'+ resultData.billNo +'/'+ resultData.upjangCode);
      } else if(resultData.resultCode === 'W002') {
        alert('결제를 취소했습니다.\n[' + resultData.resultCode +'] '+resultData.resultMessage);
        this.$router.push('/order');
      } else {
        alert('주문에 실패했습니다.\n[' + resultData.resultCode +'] '+resultData.resultMessage);
        this.$router.push('/upjang');
      }
    },
  }
};
</script>
